import { NewStockClassDraft } from '@commenda/api';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { STAGED_STOCK_CLASS_ID } from '../constants';
import { StockClassField } from './StockClassField';

interface StakeholderStockClassFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  corporationId: number;
  stagedDraft: NewStockClassDraft | null;
  setStagedDraft: (draft: NewStockClassDraft | null) => void;
  onError?: (message: string) => void;
}

export const StakeholderStockClassField = <T extends FieldValues>({
  control,
  name,
  corporationId,
  stagedDraft,
  setStagedDraft,
  onError,
}: StakeholderStockClassFieldProps<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <StockClassField
        corporationId={corporationId}
        stockClassId={field.value as string | undefined}
        stagedDraft={stagedDraft}
        onPickExisting={(id) => {
          // Empty, not undefined: react-hook-form resolves an undefined field back to
          // its defaultValue.
          field.onChange(id ?? '');
          setStagedDraft(null);
        }}
        onStageDraft={(draft) => {
          setStagedDraft(draft);
          field.onChange(STAGED_STOCK_CLASS_ID);
        }}
        onError={onError}
        errorMessage={fieldState.error?.message}
      />
    )}
  />
);
